import { FaSpinner } from "react-icons/fa";

const WizardLoading = () => {
    return <div className="fa-2x p-2">
        <div style={{}}><FaSpinner className="fa-spin" /></div>
    </div>
};

export default WizardLoading;